export const FranchiseResource = [
    "$resource",
    ($resource: any): any => {
        return $resource("/xapi/franchise/:id", { id: "@id", editions: null });
    },
];
